import classNames from 'classnames';
import React from 'react';
import { MaterialIconName } from '../types/materialIconName';
import { MaterialIcon } from './MaterialIcon';

interface StepperProps {
  steps: { icon: MaterialIconName }[];
  activeStep: number;
  customWrapperStyles?: string;
}

export const Stepper: React.FC<StepperProps> = ({
  steps,
  activeStep,
  customWrapperStyles,
}) => {
  return (
    <div
      className={
        customWrapperStyles
          ? customWrapperStyles
          : 'flex w-full items-center gap-2'
      }
    >
      {steps.map((item, index) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        return (
          <React.Fragment key={`step_${item.icon}`}>
            <div
              className={classNames(
                'flex size-8 shrink-0 items-center justify-center rounded-full bg-primary-50 md:size-10',
                {
                  'bg-primary-700': isActive || isCompleted,
                },
              )}
            >
              <MaterialIcon
                icon={isCompleted ? 'done' : item.icon}
                className={classNames(
                  'cursor-default outline-none text-white',
                  { '!text-primary-700': index > activeStep },
                )}
              />
            </div>
            {index < steps.length - 1 && (
              <div className="h-px w-full bg-primary-300" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
